module.exports = __webpack_public_path__ + "img/Support-skill-300.556dbe14.png";